import { render, staticRenderFns } from "./OrderCompletionMarkDispatchRequestAsShipped.vue?vue&type=template&id=4a39cd84&scoped=true&"
import script from "./OrderCompletionMarkDispatchRequestAsShipped.vue?vue&type=script&lang=js&"
export * from "./OrderCompletionMarkDispatchRequestAsShipped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a39cd84",
  null
  
)

export default component.exports